﻿import React from 'react';
import { PuffLoader } from 'react-spinners';

export default function Loader(): JSX.Element {
    return (
        <div className="Loader">
            <PuffLoader
                size={100}
                loading={true}
                speedMultiplier={0.8}
                color="rgb(225, 225, 225)"
            />
        </div>
    )
}